export const coursesDetails = [
  {
    title: "Introduction to User Experience Design",
    price: "45.00",
    author: "John Doe",
    rating: "4.6",
    totalRatings: 250,
    details: "22 Total Hours. 155 Lectures. All levels",
  },
  {
    title: "Introduction to User Experience Design",
    price: "45.00",
    author: "John Doe",
    rating: "4.6",
    totalRatings: 250,
    details: "22 Total Hours. 155 Lectures. All levels",
  },
  {
    title: "Introduction to User Experience Design",
    price: "45.00",
    author: "John Doe",
    rating: "4.6",
    totalRatings: 250,
    details: "22 Total Hours. 155 Lectures. All levels",
  },
];
